import React from "react";

export const YesNoCell = ({ dataItem, field, tdProps, invertColor = false, invertAnswer = false, noColors = false }) => {
    const value = dataItem?.[field];
    const displayValue = (value && !invertAnswer) || (!value && invertAnswer) ? "Yes" : "No";
    const color = noColors ? undefined : ((value && !invertColor) || (!value && invertColor) ? "green" : "red");

    return (
        <td {...tdProps}>
            <span style={{ color }}>{displayValue}</span>
        </td>
    );
};